import React from "react";
import { hasOwn } from "@core/utility/utility";
import "font-awesome/css/font-awesome.min.css";
import Card from "react-bootstrap/Card";
import ReactCountryFlag from "react-country-flag";
import commaFormat from "../../../utils/commaFormat";
import moment from "moment";
import UpgradeIconSmall from "./../../../assets/images/zap-icon.svg";
import { CardDeck, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "./styles/hs-code-profile.scss";
import { globalCountryDetailsDictionary } from "../../../core/global/global-country-details";
import { getApiUrl } from "../../../utils/baseUrl";
import { getPaymentsUrl } from "../../../utils/paymentsUrl";
import { getIntelUrl } from "../../../utils/intelUrl";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import LocalStorageService from "../../../core/services/local-storage.service";
import LoaderImg from "./../../../assets/images/loader.gif";
import trackingEventDictionary from "../../../core/dictionary/tracking-event";
import IntelLayout from "../../../components/layout/layout";
import WorldMapChart from "../../../core/charts/WorldMapChart";
import { trademoTrackingEvents } from "../../../core/global/trademo-tracking";
import { generateTrackingObject } from "../../../core/global/global-country-functions";
import ControlsComponent from "../../../shared/controls/controls.component";
import NudgePopup from "../../../shared/country-components/nudgePopup";
import { globalAPIDictionary as globalApiEndPoints } from "../../../../src/core/global/global-country-dictionary";
import { getCreditsByPlanHandler, getUserProfileHandler } from "@redux/User/userDetails.action";
import { connect } from "react-redux";
import { isProfileAccess } from "@helpers/profileHelper";
import { DATASET_TYPE_MAPPING, HIDE_DATASET_IDENTITY } from "@core/dictionary/global";
import { captureException } from "@sentry/react";

const localStorageService = LocalStorageService.getService();
const urlSearchParams = new URLSearchParams(window.location.search);
const ref = React.createRef();
let nudgePopupTimer = null; // this is used to clear timeout for nudge popup
const currentTabEnum = {
  shipment: "SHIPMENT",
  control: "CONTROL",
};
const apiEndPoints = {
  getHSCode: getApiUrl("hscode_profile/getHSCodeProfileSummary"),
  getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
};
const allCountryDictionary = globalCountryDetailsDictionary;

const globalNudgeObjectPopupData = {
  hscode_profile_controls: {
    htmlId: "hscode-profile-controls",
    key: "hscode_profile_controls",
    shouldPop: false,
    iconUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1700199690/intel/icons/gavel_rue0f6.svg",
    backgroundImgUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1683696044/intel/icons/nudge_bg_jpxg8m.svg",
    applyButtonText: "View Controls",
    cancelButtonText: "Close",
    timer: 4000, // in mili seconds (minus 1 sec than requirement)
  },
};
class HsCodeProfile extends React.Component {
  constructor(props) {
    super(props);
    const tempCurrentHSCode = props.match.params.hsCodeID;
    const tempCountry = new URLSearchParams(props.location.search).get("country");
    const tempCountryType = new URLSearchParams(props.location.search).get("type");
    const comingFrom = new URLSearchParams(props.location.search).get("comingFrom");
    this.state = {
      currentHSCode: tempCurrentHSCode,
      countryName: !comingFrom && tempCountry ? tempCountry.toLowerCase() : "",
      countryType: !comingFrom && tempCountryType ? tempCountryType : "",
      dataList: [],
      count: 0,
      currentTab: currentTabEnum.shipment,
      hsCodeSummary: {},
      countryDictionary: {},
      getInTouchPopUp: false,
      showNotification: false,
      id: null,
      userDetail: {},
      nudgePopupStateObj: { ...globalNudgeObjectPopupData },
      showNudgePopup: false,
      currentNudgePopupKey: null,
    };
  }

  // Below is the Use Effect for this Company Search Component
  componentDidMount() {
    const profileAccess = isProfileAccess("hsCode");
    if (!profileAccess?.hsCode) {
      window.location.href = "/sample-hs-code-profile";
    } else {
      this.getHsCodeDetails();
      if (this.state.countryName && this.state.countryType) {
        this.mapCountryDictionary();
      }
      this.callNudgeStatus();
      this.intelSearchHookHandler();
    }
  }

  callNudgeStatus = () => {
    let { user_active_plan: currentUserPlan } = JSON.parse(localStorage.getItem("userCurrentPlan")) || {};
    axios.get(globalApiEndPoints.featureNudge + `?plan_id=${currentUserPlan}`).then((res) => {
      if (res.data && Array.isArray(res.data) && res.data.length) {
        let tempObj = { ...this.state.nudgePopupStateObj };
        res.data.map((item) => {
          if (item.feature && this.state && this.state.nudgePopupStateObj && hasOwn(this.state.nudgePopupStateObj, item.feature)) {
            tempObj[item.feature]["shouldPop"] = item.should_pop !== undefined ? item.should_pop : false;
            tempObj[item.feature]["header"] = item.text && item.text.header ? item.text.header : "";
            tempObj[item.feature]["description"] = item.text && item.text.sub ? item.text.sub : "";
          }
        });
        this.setState({ nudgePopupStateObj: { ...tempObj } }); // storing BE data in state
      }
    });
  };

  handleNudgePopup = (key, callingFrom, event, isPoped) => {
    if (!key) return;
    if (callingFrom && callingFrom === "event") {
      // checking if function called from pre render event

      if (nudgePopupTimer) {
        clearTimeout(nudgePopupTimer);
      }

      nudgePopupTimer = setTimeout(
        () => {
          if (key === "hscode_profile_controls" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && hasOwn(this.state.nudgePopupStateObj, key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
            this.setState({
              currentNudgePopupKey: key,
              showNudgePopup: true,
            });
          }
        },
        this.state.nudgePopupStateObj[key].timer ? this.state.nudgePopupStateObj[key].timer : 4000
      );
    } else if (callingFrom && callingFrom === "popup") {
      // checking if function called from post popup render event
      axios.get(globalApiEndPoints.featureNudgeUpdate + `?is_popped=${isPoped !== undefined ? isPoped : true}&feature_name=${key}`);
      this.setState({
        showNudgePopup: false,
      });
      let tempObj = { ...this.state.nudgePopupStateObj };
      if (this.state && this.state.nudgePopupStateObj && hasOwn(this.state.nudgePopupStateObj, key)) {
        tempObj[key]["shouldPop"] = false;
      }

      this.setState({ nudgePopupStateObj: { ...tempObj } });
      if (event && event === "apply") {
        if (key === "hscode_profile_controls") {
          this.setState({
            currentTab: currentTabEnum.control,
          });
          const firstTab = document.getElementsByClassName("nav-item nav-link")[0];
          const secondTab = document.getElementsByClassName("nav-item nav-link")[1];
          if (firstTab && secondTab) {
            firstTab.classList.remove("active");
            secondTab.classList.add("active");
          }
        }
      }
    }
  };

  mapCountryDictionary() {
    let obj = {};
    if (this.state.countryName && this.state.countryType && allCountryDictionary[`${this.state.countryName.toLowerCase()}_${this.state.countryType.toLowerCase()}`]) {
      obj = { ...allCountryDictionary[`${this.state.countryName.toLowerCase()}_${this.state.countryType.toLowerCase()}`] };
    } else if (this.state.countryName && this.state.countryType) {
      obj = { ...this.getCurrentCountryDictionary(this.state.countryName.toLowerCase(), this.state.countryType.toLowerCase()) };
    }
    this.setState({
      countryDictionary: { ...obj },
    });
    setTimeout(() => {
      this.getUserPlan();
    }, 200);
  }
  getCurrentCountryDictionary(countryName, countryType) {
    for (const value of Object.values(allCountryDictionary)) {
      if (value && value.countryType && countryType === value.countryType && (value.country_small === countryName || (value.country_CamelCase && value.country_CamelCase.toLowerCase() === countryName) || (value.countryShortHand && value.countryShortHand.toLowerCase() === countryName))) {
        return value;
      }
    }
  }
  handleGetInTouchClose() {
    trademoTrackingEvents(trackingEventDictionary.hsCodeProfileGetInTouch, generateTrackingObject((this.state.countryName + "-" + this.state.countryType).toLowerCase(), this.props.location.pathname, this.state.userCredit && !!this.state.userCredit.user_active_plan ? this.state.userCredit.user_active_plan : localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : ""));
    this.setState({
      getInTouchPopUp: false,
    });
  }
  handleGetInTouchSubmit = () => {
    this.setState({
      getInTouchPopUp: false,
    });
    trademoTrackingEvents(trackingEventDictionary.hsCodeProfileGetInTouch, generateTrackingObject((this.state.countryName + "-" + this.state.countryType).toLowerCase(), this.props.location.pathname, this.state.userCredit && !!this.state.userCredit.user_active_plan ? this.state.userCredit.user_active_plan : localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : ""));
    const params = {
      planId: localStorageService && localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : "",
      countries: this.state.countryName + " " + this.state.countryType + ", requested this dataset for HS Code " + this.state.currentHSCode,
      key: "HS Code Profile",
    };
    axios
      .get(getApiUrl("notifySales"), { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch((err) => {
        captureException(err);
        toast.error("Something went wrong. Please try again later !!!");
      });
  };
  getUserPlan() {
    const params = { product_id: this.state.countryDictionary.product_id };
    axios.get(apiEndPoints.getUserPlanDetails, { params }).then(
      (res) => {
        if (!!res && !!res.data && !!res.data.data && !!res.data.data.length > 0) {
          this.setState({
            userCredit: res.data.data[0],
          });
        }
        if (res?.data?.isUpdated) {
          this.props.getCreditsByPlan();
          this.props.getUserProfile({ isUpdated: true });
        }
      },
      (error) => {
        captureException(error);
      }
    );
  }
  // End of the above code
  getHsCodeDetails = () => {
    let reqObj = {
      hs_code: this.state.currentHSCode,
      data_source: this.state.countryType,
      country: this.state.countryDictionary && this.state.countryDictionary.country_small ? this.state.countryDictionary.country_small : this.state.countryName,
    };
    axios
      .post(apiEndPoints.getHSCode, reqObj)
      .then((res) => {
        if (res && res.data && res.data.data) {
          this.setState({
            hsCodeSummary: res.data.data,
          });
          if (!this.state.countryName) {
            let tempCountry = "";
            let tempType = this.state.countryType ? this.state.countryType : "imports";
            if (res.data.data.null_landing && res.data.data.null_landing.country) {
              tempCountry = res.data.data.null_landing.country;
            } else if (res.data.data.source_wise_shipment_list[0] && res.data.data.source_wise_shipment_list[0].country_name) {
              tempCountry = res.data.data.source_wise_shipment_list[0].country_name;
              if (tempCountry.toLowerCase() === "multicountry" && res.data.data.source_wise_shipment_list[1] && res.data.data.source_wise_shipment_list[1].country_name) {
                tempCountry = res.data.data.source_wise_shipment_list[1].country_name;
              }
            }
            if (!this.state.countryType && res.data.data.null_landing && res.data.data.null_landing.data_source) {
              tempType = res.data.data.null_landing.data_source;
            } else if (res.data.data.source_wise_shipment_list[0].source) {
              tempType = res.data.data.source_wise_shipment_list[0].source;
            }
            this.setState({
              countryName: this.getCurrentCountryDictionary(tempCountry.toLowerCase(), tempType.toLowerCase()).countryShortHand ? this.getCurrentCountryDictionary(tempCountry.toLowerCase(), tempType.toLowerCase()).countryShortHand : tempCountry.toLowerCase(),
              countryType: tempType.toLowerCase(),
            });
            setTimeout(() => {
              this.mapCountryDictionary();
            }, 200);
          }
        }
      })
      .catch((err) => {
        captureException(err);
        toast.error("Something went wrong! Please try again.");
      });
  };

  // End of the above code
  // below function is for hs code select handle
  handleHsCodeSelectCall = () => {
    return;
  };
  // end of above code
  // Below code is for the Data Handler for the Notification
  // End of the above code
  handleViewShipment = () => {
    trademoTrackingEvents(trackingEventDictionary.hsCodeProfileViewShipmentsButton, generateTrackingObject((this.state.countryName + "-" + this.state.countryType).toLowerCase(), this.props.location.pathname, this.state.userCredit && !!this.state.userCredit.user_active_plan ? this.state.userCredit.user_active_plan : localStorageService.getUserCurrentPlan() ? localStorageService.getUserCurrentPlan() : ""));
    let url = `${this.state.countryDictionary.countryPathName}?redirectingFrom=hs-code-profile&hsCode=${this.state.currentHSCode}`;
    if (window.location.href.includes("multicountry")) {
      window.open(getIntelUrl() + url + "&viewType=aggregate");
    } else {
      window.open(getIntelUrl() + url);
    }
  };
  redirectCountry = (item) => {
    let tempCountry = item.country_name && item.source && this.getCurrentCountryDictionary(item.country_name.toLowerCase(), item.source.toLowerCase()) && this.getCurrentCountryDictionary(item.country_name.toLowerCase(), item.source.toLowerCase()).countryShortHand ? this.getCurrentCountryDictionary(item.country_name.toLowerCase(), item.source.toLowerCase()).countryShortHand : item.country_name ? item.country_name.toLowerCase() : "";
    let url = `hs-code/${this.state.currentHSCode}?country=${tempCountry}&type=${item.source.toLowerCase()}`;
    window.location.href = getIntelUrl() + url;
  };
  upgradeNow = () => {
    window.location.href = getPaymentsUrl() + "payment?T=" + localStorageService.getAccessToken() + "&I=" + localStorageService.getSessionID() + "&D=" + localStorageService.getSessionExpiryDate() + "&type=plans&P=" + localStorageService.getUserProduct();
  };

  intelSearchHookHandler = async () => {
    let country = urlSearchParams.get("country");
    let dataSource = urlSearchParams.get("type");
    try {
      let {
        data: { data },
      } = await axios.post(globalApiEndPoints.intelSearchHooks, {
        search: this.state.currentHSCode,
        key: "product_hscode",
        country: country ?? "multicountry",
        trade_direction: dataSource ? dataSource + "s" : "imports",
      });

      let {
        data: {
          data: { id },
        },
      } = await axios.post(globalApiEndPoints.saveIntelComplianceUserHooks, {
        country: data.country_code_list[0],
        trade_direction: dataSource + "s",
        hs_code_list: data.hs_code_list,
        country_code_list: data.country_code_list,
      });
      this.handleNudgePopup("hscode_profile_controls", "event");
      this.setState({
        id: id,
      });
    } catch (err) {
      this.setState({
        id: null,
      });
    }
  };

  userDetails = (data) => {
    this.setState({
      userDetail: data,
    });
  };

  render() {
    return (
      <div className={this.state.showNudgePopup === true && this.state.currentNudgePopupKey && this.state.nudgePopupStateObj && hasOwn(this.state.nudgePopupStateObj, this.state.currentNudgePopupKey) && this.state.nudgePopupStateObj[this.state.currentNudgePopupKey].shouldPop === true ? "disable-scroll" : ""}>
        <IntelLayout
          setNotification={(val) => {
            this.setState({
              showNotification: val,
            });
          }}
          pageTitle="HS Code | Trademo Intel"
          showNotification={this.state.showNotification}
          dataList={this.state.dataList}
          count={this.state.count}
          hsCodeApplyCalled={(e, type) => this.handleHsCodeSelectCall(e, type)}
          defaultLayout={true}
          type={"hscode"}
          countryDetails={{ countryName: this.state.countryName.toLowerCase(), countryType: this.state.countryType.toLowerCase() }}>
          <div className="trademo-new-container m-3 p-0" ref={ref}>
            <div className="hscode-profile company-profile">
              <div>
                <div className="ml-3">
                  <h5>HS Code - {this.state.currentHSCode}</h5>
                  <p>{this.state.hsCodeSummary && this.state.hsCodeSummary.description && typeof this.state.hsCodeSummary.description === "string" ? this.state.hsCodeSummary.description : ""}</p>
                </div>
              </div>
              <div className="container-fluid px-0 pb-5 pt-2">
                <div className="trademo-tab-panel">
                  <nav className="w-100 px-2">
                    <div className="nav nav-tabs search-tabs" id="nav-tab" role="tablist">
                      <a
                        onClick={() => {
                          this.setState({
                            currentTab: currentTabEnum.shipment,
                          });
                        }}
                        className="nav-item nav-link active"
                        id="nav-shipment-tab"
                        data-toggle="tab"
                        href="#nav-shipment"
                        role="tab"
                        aria-controls="nav-shipment"
                        aria-selected="true">
                        Shipments
                      </a>
                    </div>
                  </nav>
                  <div className="tab-content" id="nav-tabContent">
                    {this.state.currentTab === currentTabEnum.shipment ? (
                      <div className="container-fluid px-0 tabs-first pb-5 pt-2">
                        {this.state.countryDictionary && this.state.countryDictionary.country_small && this.state.hsCodeSummary && this.state.hsCodeSummary.source_wise_shipment_list ? (
                          <div>
                            <CardDeck>
                              <Card>
                                <Card.Body>
                                  <div className="row">
                                    {!HIDE_DATASET_IDENTITY && (
                                      <div className="col-md-2 px-2 country-list-scroll-section">
                                        <div className="list-group trademo_country_listgroup" id="list-tab" role="tablist">
                                          {!!this.state.hsCodeSummary && this.state.hsCodeSummary.source_wise_shipment_list ? (
                                            this.state.hsCodeSummary.source_wise_shipment_list.map((item, i) => {
                                              return (
                                                <span key={i}>
                                                  {!item.count || !item.country_name || !item.source ? (
                                                    <></>
                                                  ) : (
                                                    <>
                                                      <a
                                                        onClick={
                                                          !item.isSubscribed
                                                            ? () => {
                                                                this.setState({ getInTouchPopUp: true, countryName: item.country_name, countryType: item.source });
                                                              }
                                                            : () => this.redirectCountry(item)
                                                        }
                                                        className={!item.isSubscribed ? "list-group-item-disabled  list-group-item-action-disabled list-group-item list-group-item-action" : item.country_name && this.state.countryDictionary && item.source.toLowerCase().includes(this.state.countryType.toLowerCase()) && (this.state.countryDictionary.country_small === item.country_name.toLowerCase() || (this.state.countryDictionary.countryShortHand && this.state.countryDictionary.countryShortHand.toLowerCase() === item.country_name.toLowerCase()) || this.state.countryDictionary.country_CamelCase.toLowerCase() === item.country_name.toLowerCase()) ? "list-group-item list-group-item-action active" : "list-group-item list-group-item-action"}
                                                        id="list-home-list"
                                                        data-toggle="list"
                                                        href="#list-home"
                                                        role="tab"
                                                        aria-controls="home">
                                                        <span className="d-flex align-items-center row">
                                                          {!!item.country_code && item.country_code !== "" && item.country_code === "world" ? (
                                                            <span className="col-md-3 d-flex align-items-center pl-4">
                                                              <span className="material-symbols-outlined globe-image">public</span>
                                                            </span>
                                                          ) : !!item.country_code && item.country_code !== "" ? (
                                                            <span className="col-md-3 left pr-0">
                                                              <ReactCountryFlag countryCode={item.country_code} svg data-tip={item.country_name} data-for={"countryname" + i} />
                                                              <ReactTooltip className="trademo-tooltip text-capitalize" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={"countryname" + i} />
                                                            </span>
                                                          ) : (
                                                            <></>
                                                          )}
                                                          <span className="col-md-7 right pl-2 pr-0">
                                                            <span className="d-block">
                                                              {this.state.countryDictionary && item.source && item.country_name && item.country_name.toUpperCase() !== "MULTICOUNTRY" && this.getCurrentCountryDictionary(item.country_name.toLowerCase(), item.source.toLowerCase()) && this.getCurrentCountryDictionary(item.country_name.toLowerCase(), item.source.toLowerCase()).countryShortHand ? this.getCurrentCountryDictionary(item.country_name.toLowerCase(), item.source.toLowerCase()).countryShortHand : item.country_name && item.country_name.toUpperCase() !== "MULTICOUNTRY" ? item.country_name : ""}
                                                              {item.country_name.toUpperCase() === "MULTICOUNTRY" ? "Aggregated Data" : !!item.source && item.source.toLowerCase().includes("import") ? " Imports" : " Exports"}
                                                              {DATASET_TYPE_MAPPING[`${item?.country_code?.toLowerCase()}_${item?.source?.toLowerCase()}`]}
                                                            </span>
                                                            {item.count ? <span className="d-block">{commaFormat(item.count)}</span> : <></>}
                                                          </span>
                                                          {!item.isSubscribed ? <img width={"12%"} src="https://res.cloudinary.com/drzta9shk/image/upload/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg" /> : <></>}
                                                        </span>
                                                      </a>
                                                    </>
                                                  )}
                                                </span>
                                              );
                                            })
                                          ) : (
                                            <></>
                                          )}
                                          {this.state.getInTouchPopUp ? (
                                            <Modal show={this.state.getInTouchPopUp} onHide={this.handleGetInTouchClose.bind(this)} keyboard={false} centered className="trademo-modal company-profile-get-in-touch-modal" id="hscode-profile-get-in-touch-modal">
                                              <Modal.Header>
                                                <Modal.Title>
                                                  <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1684478309/intel/icons/Lightning-alt_t9mkjb.svg" />
                                                </Modal.Title>
                                              </Modal.Header>
                                              <Modal.Body>You do not have access to this data set. Connect with your account manager to get access.</Modal.Body>
                                              <Modal.Footer>
                                                <button type="button" className="btn btn-secondary" onClick={() => this.handleGetInTouchClose()}>
                                                  Cancel
                                                </button>
                                                <button type="button" className="btn btn-primary trademo-new-btn" onClick={() => this.handleGetInTouchSubmit()}>
                                                  Get in Touch
                                                </button>
                                              </Modal.Footer>
                                            </Modal>
                                          ) : (
                                            <></>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                    <div className={`col-md-${HIDE_DATASET_IDENTITY ? 12 : 10} trademo_list_details${HIDE_DATASET_IDENTITY ? " no-country-list" : ""}`}>
                                      <div className="tab-content" id="nav-tabContent">
                                        {this.state.hsCodeSummary && this.state.hsCodeSummary.should_pop_up === true ? (
                                          <div className="d-flex justify-content-center align-items-center">
                                            <div className="no-access-card">
                                              <div className="image-container">
                                                <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1687948721/intel/icons/nudge_savesearch_icon_davwcv.svg" height={50} />
                                              </div>
                                              <div className="no-access-text">You do not have access to this data set. Connect with your account manager to get access.</div>
                                              <div className="no-access-button">
                                                <button type="button" className="btn btn-primary trademo-new-btn" onClick={() => this.handleGetInTouchSubmit()}>
                                                  Get in Touch
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="tab-pane fade show active" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
                                            <div className="row no-gutters">
                                              <div className="col-md-8">
                                                {!!this && !!this.state && !!this.state.userCredit && (!!this.state.userCredit.searchFromDate || !!this.state.userCredit.searchFromDateExports) && (!!this.state.userCredit.searchToDate || !!this.state.userCredit.searchToDateExports) ? (
                                                  <span>
                                                    <span>
                                                      Shipments available for {this.state.userCredit.user_active_plan ? (this.state.userCredit.user_active_plan.split("_")[3] === "pro2" ? "Pro Plan " : this.state.userCredit.user_active_plan.split("_")[3] ? this.state.userCredit.user_active_plan.split("_")[3] + " plan " : "current plan ") : "current plan "}
                                                      from{" "}
                                                    </span>
                                                    <strong>{this.state.countryDictionary && this.state.countryDictionary.isMonthPicker ? moment(new Date(moment(new Date(this.state.userCredit.searchFromDate.slice(0, 4) + this.state.userCredit.searchFromDate.slice(4)).toString()).format("MMM YYYY")).toString()).format("MMM YYYY") : this.props.location.search.includes("export") ? moment.utc(this.state.userCredit.searchFromDateExports).format("MMM DD, YYYY") : moment.utc(this.state.userCredit.searchFromDate).format("MMM DD, YYYY")}</strong> <span className="d-none"></span> -{" "}
                                                    <span>
                                                      <strong>{this.state.countryDictionary && this.state.countryDictionary.isMonthPicker ? <span>{moment(new Date(this.state.userCredit.searchToDate.slice(0, 4) + this.state.userCredit.searchToDate.slice(4))).format("MMM YYYY")}</span> : this.props.location.search.includes("export") ? moment.utc(this.state.userCredit.searchToDateExports).format("MMM DD, YYYY") : moment.utc(this.state.userCredit.searchToDate).format("MMM DD, YYYY")}</strong>
                                                    </span>
                                                  </span>
                                                ) : (
                                                  <></>
                                                )}
                                                {(!!this.state.hsCodeSummary && this.state.hsCodeSummary.profiles && this.state.hsCodeSummary.profiles[0] && this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range && this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range !== null && !!this.state.hsCodeSummary.profiles[0].count_shipments_date_range && this.state.hsCodeSummary.profiles[0].count_shipments_date_range !== null) || (this.state.hsCodeSummary && this.state.hsCodeSummary.profiles && this.state.hsCodeSummary.profiles[0] && this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range === 0) ? (
                                                  <>
                                                    <div className="w-75 mt-2">
                                                      <div id="hscode-profile-bar" className="progress trademo-progress-bar-default">
                                                        <div className="progress-bar" role="progressbar" style={{ width: (this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range / this.state.hsCodeSummary.profiles[0].count_shipments_date_range) * 100 + "%" }} aria-valuenow={Object.values(this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range)} aria-valuemin="0" aria-valuemax={this.state.hsCodeSummary.profiles[0].count_shipments_date_range}></div>
                                                      </div>
                                                      <div className="text-left details-text p-1">
                                                        <small>
                                                          <strong>{this.state.hsCodeSummary && this.state.hsCodeSummary.profiles && this.state.hsCodeSummary.profiles[0] && this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range > 0 ? commaFormat(this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range) : 0}</strong> <span className="grey-text">of {this.state.hsCodeSummary.profiles[0].count_shipments_date_range > 0 ? commaFormat(this.state.hsCodeSummary.profiles[0].count_shipments_date_range) : 0} shipments</span>
                                                        </small>
                                                      </div>
                                                    </div>
                                                  </>
                                                ) : (
                                                  <></>
                                                )}
                                              </div>
                                              <div className="col-md-4 text-right">
                                                <button id="view-shipment-button" type="button" className="w-100 btn btn-primary trademo-new-btn" onClick={(item) => this.handleViewShipment(item)}>
                                                  View {!(this.state.userCredit && this.state.userCredit.user_active_plan && this.state.userCredit.user_active_plan.includes("pro")) && this.state.hsCodeSummary && this.state.hsCodeSummary.profiles && this.state.hsCodeSummary.profiles[0] && !!this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range && this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range > 0 ? commaFormat(this.state.hsCodeSummary.profiles[0].count_of_shipments_source_wise_date_range) : ""} Shipments
                                                </button>
                                                {this.state.userCredit && this.state.userCredit.user_active_plan && this.state.userCredit.user_active_plan.includes("pro") ? (
                                                  <button type="button" className="px-0 btn btn-link trademo-link text-left" onClick={() => this.upgradeNow()}>
                                                    <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                                                    &nbsp;&nbsp;Upgrade to unlock all shipments
                                                  </button>
                                                ) : (
                                                  <></>
                                                )}
                                              </div>
                                            </div>
                                            <div className="hscodechartContainer">
                                              <WorldMapChart finalMapData={this.state.hsCodeSummary && this.state.hsCodeSummary.profiles && this.state.hsCodeSummary.profiles[0] && this.state.hsCodeSummary.profiles[0].countries_of_origin_list ? this.state.hsCodeSummary.profiles[0].countries_of_origin_list : []} hsCode={this.state.currentHSCode} countryType={this.state.countryType} countryName={this.state.countryDictionary.country_CamelCase} isMultiCountry={this.state.countryName && this.state.countryName.toLowerCase() === "multicountry" ? true : false} />
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </Card.Body>
                              </Card>
                            </CardDeck>
                          </div>
                        ) : (
                          <div className="loader-container">
                            <div className="loader-block">
                              <img src={LoaderImg} alt="description of gif" />
                            </div>
                          </div>
                        )}
                      </div>
                    ) : (
                      <div>
                        <div className="controls_container">
                          {/* {!!this.state.id ? <ControlsComponent id={this.state.id} hsCode={this.state.currentHSCode} userDetail={this.state.userDetail} />:null} */}
                          <ControlsComponent id={this.state.id} hsCode={this.state.currentHSCode} userDetail={this.state.userDetail} />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </IntelLayout>
        {this.state.showNudgePopup && this.state.totalSearchCount !== 0 ? <NudgePopup handleNudgePopup={(event) => this.handleNudgePopup(this.state.currentNudgePopupKey, "popup", event)} nudgePopupStateObj={this.state.nudgePopupStateObj} currentNudgePopupKey={this.state.currentNudgePopupKey} /> : <div className="d-none"></div>}
      </div>
    );
  }
}
const mapDispatchToProps = {
  getCreditsByPlan: () => getCreditsByPlanHandler(),
  getUserProfile: (data) => getUserProfileHandler(data),
};

export default connect(null, mapDispatchToProps)(HsCodeProfile);
